class CurrencyPrice extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.updatePrice = this.updatePrice.bind(this);
    }

    static ratesCache = {};

    async connectedCallback() {
        this.amount = parseFloat(this.textContent);
        await this.updatePrice();
        window.addEventListener('fizishop:currency-change', this.updatePrice);
    }

    disconnectedCallback() {
        window.removeEventListener('fizishop:currency-change', this.updatePrice);
    }

    async updatePrice() {
        console.log("currency price updated");

        this.currencyCode = localStorage.getItem('fizishop__currency') || 'CZK';

        if (this.currencyCode === 'CZK') {
            this.render(this.amount, 'CZK');
        } else {
            try {
                if (!CurrencyPrice.ratesCache[this.currencyCode]) {
                    const apiUrl = `https://fx.hrafizigo.cz/rate/${this.currencyCode}`;
                    CurrencyPrice.ratesCache[this.currencyCode] = fetch(apiUrl).then(response => response.json());
                }

                const rate = await CurrencyPrice.ratesCache[this.currencyCode];
                const convertedAmount = (this.amount * rate).toFixed(2);

                this.render(convertedAmount, this.currencyCode);
            } catch (error) {
                console.error('Error fetching currency rates:', error);
                this.render(this.amount, 'CZK');
            }
        }
    }

    render(amount, currencyCode) {
        const localeMap = {
            'CZK': 'cs-CZ',
            'PLN': 'pl-PL',
            'HUF': 'hu-HU',
            'RON': 'ro-RO',
            'EUR': 'de-DE'
        };

        const symbolMap = {
            'CZK': 'Kč',
            'PLN': 'zł',
            'HUF': 'Ft',
            'RON': 'lei',
            'EUR': '€'
        };

        const locale = localeMap[currencyCode] || 'en-US';
        const symbol = symbolMap[currencyCode] || currencyCode;

        // HUF usually doesn't have decimals
        const digits = currencyCode === 'HUF' ? 0 : 2;

        let formattedNumber;
        try {
            formattedNumber = new Intl.NumberFormat(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: digits,
                useGrouping: true
            }).format(amount / 100);
        } catch (e) {
            formattedNumber = (amount / 100).toFixed(digits);
        }

        const formattedPrice = `${formattedNumber} ${symbol}`;

        this.shadowRoot.textContent = formattedPrice;
    }
}

customElements.define('currency-price', CurrencyPrice);
